/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { EnhancementObject } from "components/EnhancedSpeech/useEnhanceSpeech";
import { Dispatch, SetStateAction, useEffect } from "react";
import {
  CompletedEnhanceSpeechTrack,
  isEnhanceSpeechCompletedSuccessfully,
} from "components/EnhancedSpeech/Utilities";
import { isMobileSize } from "components/shared/Styles";

export const useAutoSelectTrack = (
  enhancements: EnhancementObject[],
  setSelectedTrack: Dispatch<
    SetStateAction<CompletedEnhanceSpeechTrack | undefined>
  >
): void => {
  useEffect(() => {
    setSelectedTrack((previouslySelected) => {
      if (previouslySelected !== undefined || isMobileSize()) {
        return previouslySelected;
      } else {
        return enhancements
          .map((enhancement) => enhancement.track)
          .find((track): track is CompletedEnhanceSpeechTrack => {
            return isEnhanceSpeechCompletedSuccessfully(track);
          });
      }
    });
  }, [enhancements, setSelectedTrack]);
};
